/* VONNKA General 6.4. No dependencies. Country filtering is a storefront gate, not a firewall. */
(function () {
  'use strict';
  var config = JSON.parse(document.getElementById('codStoreConfig').textContent);
  var blocked = ['MA','DZ','TN','LY','EG','SD','MR'];
  var memory = {}, root = document.documentElement;
  function read(key) {
    try { var raw = localStorage.getItem(key); return raw ? JSON.parse(raw) : null; } catch (_) {}
    try { var value = sessionStorage.getItem(key); if (value) return JSON.parse(value); } catch (_) {}
    return memory[key] || null;
  }
  function write(key, value) {
    memory[key] = value;
    try { if (value === null) localStorage.removeItem(key); else localStorage.setItem(key, JSON.stringify(value)); } catch (_) {}
    try { if (value === null) sessionStorage.removeItem(key); else sessionStorage.setItem(key, JSON.stringify(value)); } catch (_) {}
  }
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    var b = new Uint8Array(24);
    if (window.crypto && crypto.getRandomValues) { crypto.getRandomValues(b); return Array.from(b,function(v){return v.toString(16).padStart(2,'0');}).join(''); }
    return Date.now().toString(36) + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
  }
  var cookie = document.cookie.match(/(?:^|; )cod_client=([A-Za-z0-9_-]+)/);
  var clientId = cookie ? cookie[1] : read('cod_client') || uuid();
  write('cod_client',clientId);
  try { document.cookie = 'cod_client=' + clientId + '; Max-Age=31536000; Path=/; SameSite=Lax; Secure'; } catch (_) {}
  function country(c) { c=String(c || '').trim().toUpperCase();return c==='RDC'?'CD':c; }
  var dial={CI:'225',BF:'226',GA:'241',BJ:'229',NE:'227',TG:'228',TD:'235',SN:'221',ML:'223',CG:'242',CM:'237',GN:'224',CD:'243',ID:'62',ES:'34',KE:'254',TZ:'255',UG:'256'};
  var lengths={CI:[10],BF:[8],GA:[8,9],BJ:[10],NE:[8],TG:[8],TD:[8],SN:[9],ML:[8],CG:[9],CM:[9],GN:[9],CD:[9],ID:[9,10,11,12],ES:[9],KE:[9],TZ:[9],UG:[9]};
  function normalizePhone(raw,c) {
    c=country(c);raw=String(raw || '').trim();
    if (!dial[c] || !/^[+\d\s().-]+$/.test(raw)) throw Error('Vérifiez votre numéro de téléphone.');
    var n=raw.replace(/\D/g,''), international=raw.charAt(0)==='+' || n.indexOf('00')===0;
    if(n.indexOf('00')===0)n=n.slice(2);
    if(international && n.indexOf(dial[c])!==0)throw Error('Utilisez le numéro du pays de livraison.');
    if(n.indexOf(dial[c])===0 && (international || n.length>Math.max.apply(null,lengths[c])))n=n.slice(dial[c].length);
    if(c==='CI' && /^[1-9]\d{8}$/.test(n))n='0'+n;
    if(['CD','ID','KE','TZ','UG'].indexOf(c)>=0)n=n.replace(/^0/,'');
    if(lengths[c].indexOf(n.length)<0)throw Error('Vérifiez le nombre de chiffres du téléphone.');
    return '+'+dial[c]+n;
  }
  function fetchCountry(url) {
    return new Promise(function(resolve,reject){
      var ctrl = window.AbortController ? new AbortController() : null;
      var timer=setTimeout(function(){if(ctrl)ctrl.abort();reject(Error('timeout'));},2500);
      fetch(url,{credentials:'omit',referrerPolicy:'no-referrer',signal:ctrl?ctrl.signal:undefined}).then(function(r){if(!r.ok)throw Error('geo');return r.json();}).then(function(j){
        var c=country(j.country_code || j.country);if(!/^[A-Z]{2}$/.test(c))throw Error('geo');clearTimeout(timer);resolve(c);
      }).catch(function(e){clearTimeout(timer);reject(e);});
    });
  }
  function locate() {
    var cached;
    try {cached=JSON.parse(sessionStorage.getItem('cod_geo_v1'));}catch(_){}
    if(cached && cached.at>Date.now()-1800000 && /^[A-Z]{2}$/.test(cached.country))return Promise.resolve(cached.country);
    return fetchCountry('https://api.country.is/').catch(function(){return fetchCountry('https://ipapi.co/json/');}).then(function(c){
      try{sessionStorage.setItem('cod_geo_v1',JSON.stringify({country:c,at:Date.now()}));}catch(_){}return c;
    });
  }
  var api={read:read,write:write,uuid:uuid,clientId:clientId,country:country,dial:dial,normalizePhone:normalizePhone,visitor:'',allowed:false};
  window.COD=api;
  function gate(c,preview) {
    api.visitor=c;
    var vendor=country(config.vendor), denied=blocked.indexOf(c)>=0;
    api.allowed=!preview && !denied && !!c && (!config.isProduct || !!dial[vendor] && (c==='ID' || c===vendor));
    var visible=preview || api.allowed;
    root.dataset.codAccess=visible?'allowed':'denied';
    if(!visible){
      document.getElementById('codGateTitle').textContent=c?'Service indisponible':'Vérification interrompue';
      document.getElementById('codGateText').textContent=c?'Ce produit ou ce service n’est pas disponible dans votre pays.':'Nous ne pouvons pas vérifier votre pays pour le moment. Réessayez dans un instant.';
      document.getElementById('codGateRetry').hidden=!!c;
    }
    document.querySelectorAll('[data-vendor]').forEach(function(card){var v=country(card.dataset.vendor);card.hidden=!(preview || api.allowed && !!dial[v] && (c==='ID' || v===c));});
    document.querySelectorAll('.catalog-empty').forEach(function(el){el.hidden=!!el.parentNode.querySelector('[data-vendor]:not([hidden])');});
    return api;
  }
  api.ready=config.designMode?Promise.resolve(gate('',true)):locate().then(function(c){return gate(c,false);}).catch(function(){return gate('',false);});
  document.getElementById('codGateRetry').addEventListener('click',function(){location.reload();});
  function jsonp(url,data,timeout) {
    return new Promise(function(resolve,reject){
      var cb='cod_cb_'+uuid().replace(/-/g,''), script=document.createElement('script'), done=false;
      function clean(){clearTimeout(timer);script.remove();delete window[cb];}
      function finish(error,value){if(done)return;done=true;clean();error?reject(error):resolve(value);}
      window[cb]=function(j){finish(null,j);};
      var timer=setTimeout(function(){finish(Error('timeout'));},timeout||8000);
      var params=new URLSearchParams(data);params.set('callback',cb);params.set('_',String(Date.now()));
      script.src=url+(url.indexOf('?')<0?'?':'&')+params.toString();script.referrerPolicy='no-referrer';
      script.onerror=function(){finish(Error('network'));};document.head.appendChild(script);
    });
  }
  api.status=function(url,event){return jsonp(url,{action:'status',eventId:event});};
  api.send=function(url,payload){
    // One POST. If its response is lost, callers perform read-only status checks.
    return new Promise(function(resolve,reject){
      var timer=setTimeout(function(){reject(Error('unknown'));},15000);
      fetch(url,{method:'POST',headers:{'Content-Type':'text/plain;charset=UTF-8'},body:JSON.stringify(payload),credentials:'omit',redirect:'follow',referrerPolicy:'no-referrer'}).then(function(r){if(!r.ok)throw Error('unknown');return r.json();}).then(function(r){clearTimeout(timer);resolve(r);}).catch(function(e){clearTimeout(timer);reject(e);});
    });
  };
})();
